// components/StyledCard.tsx
import React from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Center, Stack , Link} from '@chakra-ui/react';
import { Link as RouterLink } from "react-router-dom";

import { Text } from "@chakra-ui/react"


const styles = {
  cardclass: {
    padding: 10,
    border: '1px solid #ccc',
    borderRadius: 8,
    margin: '16px 0',
    display: "block"
  },
  headerclass : {
    bold: true
  }
};



interface Props extends WithStyles<typeof styles> {
  headline: string;
  description: string;
  image: string;
  targetPageId:string ;
  route: string;
}

function ServiceCard(props: Props) {
  const toSection = (section: string) => {
    document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
} ;
  const { classes, headline, description, image } = props;
  return (
    <div className={classes.cardclass}>
      <Link as={RouterLink} to={props.route}
                                          variant="link"
                                          textDecoration="underline"
                                          textDecorationThickness="2px"
                                          onClick={() => toSection(props.targetPageId)}
                                          data-aos="fade"
                                          data-aos-delay="200"
                                          >
      <Center><h2 className={classes.headerclass}><b>{headline}</b></h2></Center>
      </Link>
      <Link as={RouterLink} to={props.route}
                                          variant="link"
                                          textDecoration="underline"
                                          textDecorationThickness="2px"
                                          onClick={() => toSection(props.targetPageId)}
                                          data-aos="fade"
                                          data-aos-delay="200"
                                          >
      <Center><img src={image} alt="" /></Center>
      </Link>
      <Stack spacing={3} style={{padding:"15px"}}>
        <Text   fontSize='md' color='#800080' as='em' ><b>{description}</b></Text>
        <Text   fontSize='md' color='#800080' as='em' >
           <Link as={RouterLink} to={props.route}
                                          variant="link"
                                          textDecoration="underline"
                                          textDecorationThickness="2px"
                                          onClick={() => toSection(props.targetPageId)}
                                          data-aos="fade"
                                          data-aos-delay="200"
                                          >Learn More</Link>
        </Text>
      </Stack>

    </div>
  );
}

export default withStyles(styles)(ServiceCard);
